"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorsStateProvider = exports.useErrorsState = void 0;
const unstated_next_1 = require("unstated-next");
const react_1 = require("react");
const useErrorsStateContainer = unstated_next_1.createContainer(() => {
    const [codeErrors, setCodeErrors] = react_1.useState([]);
    const [grafErrors, setGrafErrors] = react_1.useState();
    const [lockGraf, setLockGraf] = react_1.useState(false);
    const [lockCode, setLockCode] = react_1.useState(false);
    return { codeErrors, setCodeErrors, grafErrors, setGrafErrors, lockGraf, lockCode, setLockGraf, setLockCode };
});
exports.useErrorsState = useErrorsStateContainer.useContainer;
exports.ErrorsStateProvider = useErrorsStateContainer.Provider;
